import React from 'react'
import { useInView } from 'react-intersection-observer'
import { ROW_HEIGHT } from '../Entry'

export default function PaginationLoader({ listState, fetchNextPage }) {
  const load = React.useCallback(
    ({ startFresh = false } = {}) => {
      if (
        !listState.error &&
        !listState.loading &&
        listState.pageInfo.hasNextPage
      ) {
        fetchNextPage({ startFresh })
      }
    },
    [
      listState.error,
      listState.loading,
      listState.pageInfo.hasNextPage,
      fetchNextPage,
    ]
  )

  React.useEffect(
    () => {
      load({ startFresh: false })
    },
    [load]
  )
  return <Loader load={() => load()} />
}

export function Loader({ load, margin = ROW_HEIGHT * 20 }) {
  const [ref, inView] = useInView({
    /* Optional options */
    threshold: 0,
  })

  React.useEffect(
    () => {
      if (inView) {
        load()
      }
    },
    [inView, load]
  )

  return (
    <div
      style={{
        height: 0,
        overflow: 'visible',
        position: 'relative',
      }}
    >
      <div
        ref={ref}
        style={{
          position: 'absolute',
          height: margin,
          width: '100%',
          pointerEvents: 'none',
          top: `${-margin / 2}px`,
        }}
      />
    </div>
  )
}
